import React, { Fragment, useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import path from 'path';
import { session as sessionHelper } from '@signiapp/helpers';
import { LoginRequired } from '@signiapp/helpers/errors';
import { Spinner } from '@signicat/designi/components/loaders';
import { Empty } from '@signicat/designi/components/containers';
import Route from '@signiapp/core/components/Route.js';
import { t } from "./helpers/i18n";
import { module as moduleActions, feed as feedActions } from "./store/actions";
import { setTranslationMissing } from "./store/actions/module";
import { Root, Create, DeveloperSettings } from "./routes";
import { Notifications } from "./components";
var App = function App(props) {
  var match = props.match,
    location = props.location,
    session = props.session,
    language = props.language,
    groups = props.groups,
    features = props.features;
  var basename = match.path;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    module = _useSelector.module;
  var stateSession = useSelector(function (state) {
    return state.session;
  });
  var dispatch = useDispatch();
  if (sessionHelper.isAuthenticated !== true) {
    throw LoginRequired();
  }
  useEffect(function () {
    dispatch(setTranslationMissing({
      showNotification: false,
      url: location.pathname
    }));
  }, [location]);
  useEffect(function () {
    dispatch({
      type: 'SESSION_SET_ALL',
      session: session
    });
  }, [session]);
  useEffect(function () {
    dispatch({
      type: 'APP_SET_GROUPS',
      groups: groups
    });
  }, [groups]);
  useEffect(function () {
    dispatch({
      type: 'APP_SET_FEATURES',
      features: features
    });
  }, [features]);
  useEffect(function () {
    dispatch({
      type: 'SET_LANGUAGE',
      language: language
    });
    dispatch(moduleActions.getDictionary(language));
  }, [language]);
  useEffect(function () {
    dispatch(feedActions.initFeed());
    dispatch(moduleActions.getDependencies());
    dispatch(moduleActions.getEnDictionary());
  }, []);
  if (module.isLoaded === false || (stateSession === null || stateSession === void 0 ? void 0 : stateSession.user) === null) {
    return /*#__PURE__*/React.createElement(Spinner, {
      fullscreen: true
    });
  }
  if (module.error) {
    return /*#__PURE__*/React.createElement(Empty, {
      emoji: "\uD83D\uDC1B",
      heading: t('module_error_loading_dependencies_title'),
      message: t('module_error_loading_dependencies_message')
    });
  }
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Notifications, null), /*#__PURE__*/React.createElement(Switch, {
    location: location
  }, /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'dev-settings'),
    component: DeveloperSettings
  }), /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'create', ':id?', ':step?'),
    component: Create
  }), /*#__PURE__*/React.createElement(Route, {
    path: basename,
    component: Root
  })));
};
export default App;